module.exports = __webpack_public_path__ + "img/cartograph-dark.71938504.png";